module.exports = __webpack_public_path__ + "img/skyblog.png";